// Each preview owns its input, counter and font selection, including editor re-renders.
(() => {
  if (customElements.get('engraving-preview')) return;
  class EngravingPreview extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.input = this.querySelector('[data-eg-input]');
      this.output = this.querySelector('[data-eg-preview]');
      this.counter = this.querySelector('[data-eg-counter]');
      this.buttons = [...this.querySelectorAll('[data-eg-font]')];
      this.limit = Math.max(1, Number.parseInt(this.dataset.limit, 10) || 15);
      if (!this.input || !this.output || !this.counter) return;
      this.input.addEventListener('input', () => this.updateText(), { signal });
      this.buttons.forEach(button => button.addEventListener('click', () => this.selectFont(button), { signal }));
      this.mobile = window.matchMedia('(max-width:749px)');
      this.mobile.addEventListener('change', () => {
        if (this.selectedFont) this.selectFont(this.selectedFont);
      }, { signal });
      this.selectFont(this.buttons.find(button => button.getAttribute('aria-pressed') === 'true') || this.buttons[0]);
      this.updateText();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
    updateText() {
      // Count code points, matching the former preview and treating CJK as single characters.
      const characters = Array.from(this.input.value).slice(0, this.limit);
      this.input.value = characters.join('');
      this.output.textContent = this.input.value || ' ';
      this.counter.textContent = (this.dataset.counterFormat || '{count} / {max}')
        .replaceAll('{count}', String(characters.length)).replaceAll('{max}', String(this.limit));
      this.counter.toggleAttribute('data-warning', characters.length > this.limit - 3);
    }
    selectFont(button) {
      if (!button) return;
      this.selectedFont = button;
      this.buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const sample = button.querySelector('[data-eg2-field="sample"]');
      if (sample) this.style.setProperty('--eg2-preview-font', getComputedStyle(sample).fontFamily);
      const size = Number(this.mobile.matches ? button.dataset.previewSizeM : button.dataset.previewSize);
      this.style.setProperty('--eg2-preview-size', `${size > 0 ? size : 22}px`);
    }
  }
  customElements.define('engraving-preview', EngravingPreview);
})();
